<div ngbDropdown>
    <a ngbDropdownAnchor id="dropdownPhone" href="tel:{{phone}}" data-offset="10,10" (contextmenu)="onRightClick($event)">{{phone}}</a>
    <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownPhone">
        <button class="dropdown-item" (click)="onSendSMSClick($event)">Contactar por SMS</button>
    </div>
</div>